/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatter Plot Maker (Free, Online) — Toolverse`)
};

const es_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Diagramas de Dispersión (Gratis, Online) — Toolverse`)
};

const de_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streudiagramm-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spreidingsdiagrammaker (gratis, online) — Toolverse`)
};

const fr_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de nuage de points (gratuit, en ligne) — Toolverse`)
};

const it_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici a dispersione (gratuito, online) — Toolverse`)
};

const pt_br2_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Dispersão (Grátis, Online) — Toolverse`)
};

const pt_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Dispersão (Grátis, Online) — Toolverse`)
};

const ja_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`散布図作成ツール（無料・オンライン） — Toolverse`)
};

const zh_scatter_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`散点图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_meta_title", locale)
	if (locale === "en") return en_scatter_meta_title(inputs)
	if (locale === "es") return es_scatter_meta_title(inputs)
	if (locale === "de") return de_scatter_meta_title(inputs)
	if (locale === "nl") return nl_scatter_meta_title(inputs)
	if (locale === "fr") return fr_scatter_meta_title(inputs)
	if (locale === "it") return it_scatter_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_meta_title(inputs)
	if (locale === "pt") return pt_scatter_meta_title(inputs)
	if (locale === "ja") return ja_scatter_meta_title(inputs)
	return zh_scatter_meta_title(inputs)
};